export enum Teams {
    Boom = 'email_campaigns',
    Mag = 'psa_and_growth',
}

export enum Features {
    Subscribers = 'subscribers',
    ManageSubscribers = 'manage_subscribers',
    TaskList = 'task_list',
    PopularTools = 'popular_tools',
    BoostTrialTourModal = 'boost_trial_tour_modal',
    BoostStartTrial = 'boost_start_trial',
    PayAsYouGo = 'pay_as_you_go',
    PostPublish = 'post_publish',
}

export enum Components {
    ImportList = 'import_a_list',
    NewList = 'new_list',
    PreviousEvents = 'previous_events',
    UploadCSV = 'upload_csv',
    ManualAdd = 'manual_add',
    ManualAddSingle = 'manual_add_single',
    ManualAddMultiple = 'manual_add_multiple',
    AddToFacebook = 'add_to_facebook',
    CreateEventInvite = 'create_event_invite',
    EbAds = 'eb_ads',
    FacebookAdCampaign = 'facebook_ad_campaign',
    VisitEventbriteAcademy = 'visit_eventbrite_academy',
    SendEmailCampaign = 'email_campaign',
    CompleteProfile = 'complete_profile',
    InstagramGrowthCampaign = 'instagram_growth',
    EmailToolCard = 'email_tool_card',
    PostToSocialToolCard = 'post_to_social_tool_card',
    PSAToolCard = 'paid_social_ads_tool_card',
    EBAdsToolCard = 'eb_ads_tool_card',
    TourModalStep1NextButton = 'tour_modal_step1_next_button',
    TourModalStep2NextButton = 'tour_modal_step2_next_button',
    TourModalStep3NextButton = 'tour_modal_step3_next_button',
    TourModalStep4NextButton = 'tour_modal_step4_next_button',
    TourModalStep5NextButton = 'tour_modal_step5_next_button',
    TourModalGetStartedButton = 'tour_modal_get_started_button',
    TourModalStep2LeftArrowButton = 'tour_modal_step2_left_arrow_button',
    TourModalStep3LeftArrowButton = 'tour_modal_step3_left_arrow_button',
    TourModalStep4LeftArrowButton = 'tour_modal_step4_left_arrow_button',
    TourModalStep5LeftArrowButton = 'tour_modal_step5_left_arrow_button',
    TourModalStep6LeftArrowButton = 'tour_modal_step6_left_arrow_button',
    TourModalStep1RightArrowButton = 'tour_modal_step1_right_arrow_button',
    TourModalStep2RightArrowButton = 'tour_modal_step2_right_arrow_button',
    TourModalStep3RightArrowButton = 'tour_modal_step3_right_arrow_button',
    TourModalStep4RightArrowButton = 'tour_modal_step4_right_arrow_button',
    TourModalStep5RightArrowButton = 'tour_modal_step5_right_arrow_button',
    TourModalStepperDot1 = 'tour_modal_stepper_dot_1',
    TourModalStepperDot2 = 'tour_modal_stepper_dot_2',
    TourModalStepperDot3 = 'tour_modal_stepper_dot_3',
    TourModalStepperDot4 = 'tour_modal_stepper_dot_4',
    TourModalStepperDot5 = 'tour_modal_stepper_dot_5',
    TourModalStepperDot6 = 'tour_modal_stepper_dot_6',
    EmailMarketingButton = 'email_marketing_button',
    SocialPostingButton = 'social_posting_button',
    FacebookEventsButton = 'facebook_events_button',
    PaidAdsButton = 'paid_ads_button',
    AdCampaignsButton = 'ad_campaigns_button',
    AudienceTargetingButton = 'audience_targeting_button',
    NotSureButton = 'not_sure_button',
    PurchaseSendsButton = 'purchase_sends_button',
    ComparePlansButton = 'compare_plans_button',
    DeclineButton = 'decline_button',
    CancelButton = 'cancel_button',
    EBAdsPostPublish = 'eb-ads',
    AddToLinkedInPostPublish = 'add-to-linkedin',
    AddToFacebookPostPublish = 'add-to-facebook',
    EmailPostPublish = 'email',
    PSAPostPublish = 'paid-social-ads',
    IGGrowthPostPublish = 'instagram-growth',
    MEAPostPublish = 'multi-event-ads',
    TrialStartCTACard = 'trial-start-cta-card',
}

export enum Actions {
    Start = 'start',
    ChooseFile = 'choose_file',
    Submit = 'submit',
    Create = 'create',
    Manage = 'manage',
    Click = 'click',
    Select = 'select',
    Deselect = 'deselect',
}
